<div
  class="align-items-md-end border-bottom-primary d-flex flex-column flex-column-reverse flex-md-row"
>
  <ul class="flex-grow-1 tabbable-nav m-0 p-0 border-0">
    <li
      [ngClass]="{ active: addressBookTabs.Personal === selectedTab }"
      (click)="selectTab(addressBookTabs.Personal)"
      *ngIf="
        !(
          securityAddressBook.hideOwnAccounts &&
          securityAddressBook.hideContacts
        )
      "
    >
      <span class="tabbable-title" *scText="tabs.personal.fields.label"></span>
    </li>
    <li
      [ngClass]="{ active: addressBookTabs.Companies === selectedTab }"
      (click)="selectTab(addressBookTabs.Companies)"
      *ngIf="!securityAddressBook.hideCompanies"
    >
      <span class="tabbable-title" *scText="tabs.companies.fields.label"></span>
    </li>
  </ul>
  <div class="search-field relative pb-1 flex-grow-1">
    <i class="icon-search"></i>
    <input
      class="form-control pr-3 pl-4"
      #searchInput
      [(ngModel)]="search"
      name="search"
      maxlength="80"
      [placeholder]="
        addressBookTabs.Personal === selectedTab
          ? personalSearch.value
          : companiesSearch.value
      "
    />
    <div
      class="search-clear-icon"
      (click)="clearValue()"
      [hidden]="!search || search.length === 0"
    >
      <i class="icon-clear-input-value"></i>
    </div>
  </div>
  <div
    class="ml-md-1 pb-1"
    *ngIf="pageMode && addressBookTabs.Personal === selectedTab"
  >
    <button class="btn btn-primary btn-text-icon" (click)="triggerAddAddress()">
      <i class="icon-payment-add-address fs-24 mr-1"></i>
      <span
        class="text-nowrap"
        *scText="items.addAddressButton.fields.label"
      ></span>
    </button>
  </div>
</div>
<div
  *ngIf="addressBookTabs.Personal === selectedTab"
  [@changeTabPersonal]
  (@changeTabPersonal.done)="
    captureDoneEvent($event, addressBookTabs.Companies)
  "
>
  <ng-container
    *ngIf="
      securityAddressBook.internalPermissionsEnabled ||
        securityAddressBook.domesticPermissionsEnabled;
      else personalTabNotPermission
    "
  >
    <ng-container *ngIf="showOwnAccounts">
      <div
        class="table-responsive-lg"
        *ngIf="
          securityAddressBook.internalPermissionsEnabled;
          else internalTransferDisabled
        "
      >
        <table class="table transfer-table table-with-letter with-hover mt-2">
          <thead>
            <tr>
              <th
                *ngFor="let column of items.ownAccountsAddressBook.fields.items"
              >
                <span *scText="column.fields.label"></span>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              *ngFor="
                let personal of ownAccountList | async;
                trackBy: trackByFn;
                let i = index
              "
              [ngClass]="{ 'table-row-odd': setOdd(i) }"
              (click)="select(personal)"
              [hidden]="ownAccountListEmpty"
            >
              <td class="text-marine-blue-two">
                {{ personal.alias || personal.description }}
              </td>
              <td class="fs-13 text-gray-900">
                {{ personal.accountNumber }}
              </td>
              <td class="fs-13 text-gray-900">
                {{ personal.portfolioName }}
              </td>
            </tr>
          </tbody>
        </table>
        <div *ngIf="ownAccountListEmpty" class="empty-page pt-4 pb-1">
          <div><i class="icon-empty-page"></i></div>
          <div
            class="fs-20"
            *scText="items.emptyMessageAccounts.fields.label"
          ></div>
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="!securityAddressBook.hideContacts">
      <div
        class="table-responsive-lg"
        *ngIf="
          securityAddressBook.domesticPermissionsEnabled;
          else externalTransferDisabled
        "
      >
        <table
          class="table transfer-table table-with-letter mt-2"
          [ngClass]="{ 'with-hover': !pageMode }"
        >
          <thead>
            <tr>
              <th
                *ngFor="
                  let column of items.beneficiariesAddressBook.fields.items
                "
              >
                <span *scText="column.fields.label"></span>
              </th>
              <th
                *ngIf="
                  beneficiariesActions && beneficiariesActions.length !== 0
                "
              ></th>
            </tr>
          </thead>
          <tbody>
            <ng-container
              *ngFor="let item of beneficiariesList | async | keyvalue"
            >
              <tr class="letter-row">
                <td colspan="3">{{ item.key }}</td>
              </tr>
              <ng-container *ngIf="item.value && item.value.length !== 0">
                <tr
                  *ngFor="
                    let beneficiary of item.value;
                    trackBy: trackByFn;
                    let i = index
                  "
                  [ngClass]="{ 'table-row-odd': setOdd(i) }"
                  (click)="select(beneficiary)"
                  [hidden]="beneficiariesListEmpty"
                >
                  <td
                    [ngClass]="{
                      'text-gray-900': pageMode,
                      'text-marine-blue-two': !pageMode
                    }"
                  >
                    {{ beneficiary.name }}
                  </td>
                  <td class="fs-13 text-gray-900">
                    {{ beneficiary.alias }}
                  </td>
                  <td class="fs-13 text-gray-900">
                    {{ beneficiary.accountNumber || beneficiary.iban }}
                  </td>
                  <td class="fs-13 text-gray-900">
                    {{
                      beneficiary.bank || beneficiary.bicCode || beneficiary.aba
                    }}
                  </td>
                  <td
                    class="text-right p--3 pr-1"
                    *ngIf="
                      beneficiariesActions && beneficiariesActions.length !== 0
                    "
                  >
                    <div class="d-flex justify-content-end">
                      <ng-container *ngFor="let action of beneficiariesActions">
                        <span
                          tooltipClass="tooltip-text"
                          [ngbTooltip]="tipContent"
                          placement="bottom"
                        >
                          <button
                            class="btn btn-white btn-icon p--6 action-buttons"
                            (click)="action.action(beneficiary)"
                            [disabled]="
                              action.disabled
                                ? !beneficiary.canCreateTransfer
                                : false
                            "
                          >
                            <i class="fs-24" [ngClass]="action.iconClass"></i>
                          </button>
                        </span>

                        <ng-template #tipContent>
                          <div
                            *ngIf="
                              !action.disabled || beneficiary.canCreateTransfer
                            "
                          >
                            {{ action.tooltip + ' ' + beneficiary.name }}
                          </div>
                          <div
                            *ngIf="
                              action.disabled && !beneficiary.canCreateTransfer
                            "
                          >
                            {{ action.disbledTooltip }}
                          </div>
                        </ng-template>
                      </ng-container>
                    </div>
                  </td>
                </tr>
              </ng-container>
            </ng-container>
          </tbody>
        </table>
        <div *ngIf="beneficiariesListEmpty" class="empty-page pt-4 pb-1">
          <div><i class="icon-empty-page"></i></div>
          <div class="fs-20" *scText="items.emptyMessage.fields.label"></div>
        </div>
      </div>
    </ng-container>
  </ng-container>
</div>
<div
  *ngIf="addressBookTabs.Companies === selectedTab"
  [@changeTabCompanies]
  (@changeTabCompanies.done)="
    captureDoneEvent($event, addressBookTabs.Personal)
  "
>
  <div
    class="table-responsive-lg"
    *ngIf="
      securityAddressBook.billTransferPermissionsEnabled;
      else billTransferDisabled
    "
  >
    <table
      class="table transfer-table table-with-letter mt-2"
      [ngClass]="{ 'with-hover': !pageMode }"
    >
      <thead>
        <tr>
          <th *ngFor="let column of items.companiesAddressBook.fields.items">
            <span *scText="column.fields.label"></span>
          </th>
          <th *ngIf="companiesActions && companiesActions.length !== 0"></th>
        </tr>
      </thead>
      <tbody [hidden]="isEmpty">
        <ng-container *ngFor="let item of companiesList | async | keyvalue">
          <tr class="letter-row">
            <td colspan="3">{{ item.key }}</td>
          </tr>
          <ng-container *ngIf="item.value && item.value.length !== 0">
            <tr
              *ngFor="
                let company of item.value;
                trackBy: trackByFn;
                let i = index
              "
              [ngClass]="{ 'table-row-odd': setOdd(i) }"
              (click)="select(company)"
            >
              <td
                [ngClass]="{
                  'text-gray-900': pageMode,
                  'text-marine-blue-two': !pageMode
                }"
              >
                {{ company.name }}
              </td>
              <td class="fs-13 text-gray-900">
                {{ company.accountNumber }}
              </td>
              <td class="fs-13 text-gray-900">
                {{ company.bank }}
              </td>
              <td
                class="text-right p--3 pr-1"
                *ngIf="companiesActions && companiesActions.length !== 0"
              >
                <div class="d-flex justify-content-end">
                  <ng-container *ngFor="let action of companiesActions">
                    <ng-template #tipContent>
                      <div *ngIf="company.canCreateBillTransfer">
                        {{ action.tooltip + ' ' + company.name }}
                      </div>
                      <div *ngIf="!company.canCreateBillTransfer">
                        {{ action.disbledTooltip }}
                      </div>
                    </ng-template>
                    <span
                      tooltipClass="tooltip-text"
                      [ngbTooltip]="tipContent"
                      placement="bottom"
                    >
                      <button
                        class="btn btn-white btn-icon p--6"
                        (click)="action.action(company)"
                        [disabled]="!company.canCreateBillTransfer"
                      >
                        <i class="fs-24" [ngClass]="action.iconClass"></i>
                      </button>
                    </span>
                  </ng-container>
                </div>
              </td>
            </tr>
          </ng-container>
        </ng-container>
      </tbody>
    </table>
    <div *ngIf="isEmpty" class="empty-page">
      <div><i class="icon-empty-page"></i></div>
      <div
        class="fs-20"
        *scText="items.emptyMessageCompanies.fields.label"
      ></div>
    </div>
  </div>
</div>
